import { Color, Icon } from '@billy/design-system'
import styled from '@emotion/styled'
import React from 'react'

import { Themable } from '../../types/themable'

type CheckmarkContainerProps = Themable & CheckmarkProps

const CheckmarkContainer = styled.div<CheckmarkContainerProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.forms.lightBackground};
  border: 1px solid ${({ theme }) => theme.colors.forms.border};
  margin-right: 8px;
  backface-visibility: hidden; // soften border edges

  ${({ checked, theme }) => {
    if (checked) {
      return `
      background-color: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      `
    }
  }}
`

type CheckmarkProps = {
  checked?: boolean
}

export const Checkmark = ({ checked }: CheckmarkProps) => {
  return (
    <CheckmarkContainer checked={checked}>{checked && <Icon icon="check" color={Color.White} />}</CheckmarkContainer>
  )
}
